import * as Yup from 'yup';

const toNumber = (_: unknown, orig: unknown) => {
  if (orig === '' || orig == null) return undefined;
  const n = Number(String(orig).replace(',', '.')); // aceita vírgula
  return Number.isFinite(n) ? n : NaN;
};

// RFC4122: 8-4-4-4-12, versão 1–8, variant 8/9/a/b
const UUID_RFC4122_ANY_VERSION =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const validationSchemaAssinatura = Yup.object({
  signature_uuid: Yup.string()
    .trim()
    .required('Assinatura é obrigatória')
    .matches(UUID_RFC4122_ANY_VERSION, 'UUID da assinatura inválido'),

  latitude: Yup.number()
    .transform(toNumber)
    .typeError('Latitude deve ser numérica')
    .required('Latitude é obrigatória')
    .min(-90, 'Latitude deve estar entre -90 e 90')
    .max(90, 'Latitude deve estar entre -90 e 90'),

  longitude: Yup.number()
    .transform(toNumber)
    .typeError('Longitude deve ser numérica')
    .required('Longitude é obrigatória')
    .min(-180, 'Longitude deve estar entre -180 e 180')
    .max(180, 'Longitude deve estar entre -180 e 180'),

  coordinate_capture_method: Yup.mixed<'AUTOMATIC' | 'MANUAL'>()
    .oneOf(['AUTOMATIC', 'MANUAL'], 'Método inválido')
    .required('Método de captura é obrigatório'),
});
